// ----------------------------------------------------------
// © Copyright 2021 European Space Agency, 2021
// This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this [source code/executable] package. No part of the package, including this file, may be copied, modified, propagated, or distributed except according to the terms contained in the file ‘LICENSE.txt’.
// -----------------------------------------------------------
import { isUndefined } from "./check";
import { routingExtraInfo } from "../store";
export const CURRENT_BASE_VERSION = 1915;
export const openLabInWindow = (hostname) => {
    return window.open(hostname);
};
export const closeLabInWindow = (lab) => {
    lab.close && lab.close();
};
/**
 * Show/hide a section identified with
 * the id provied in parameter
 * @param event the event from which the expand is triggered
 * @param id the identified of the element to show
 */
export const expand = (event, id) => {
    const contentElement = document.getElementById(id);
    contentElement.style.visibility = "initial";
    contentElement.style.height = "auto";
    event.target.style.visibility = "hidden";
    event.target.style.width = 0;
    event.target.nextElementSibling.style.visibility = "initial";
    event.target.nextElementSibling.style.width = null;
};
/**
 * Show/hide a section identified with
 * the id provied in parameter
 * @param event the event from which the expand is triggered
 * @param id the identified of the element to show
 */
export const collapse = (event, id) => {
    const contentElement = document.getElementById(id);
    // reset the style to have the one from the CSS
    contentElement.style.visibility = null;
    contentElement.style.height = null;
    event.target.style.visibility = "hidden";
    event.target.style.width = 0;
    event.target.previousElementSibling.style.visibility = "initial";
    event.target.previousElementSibling.style.width = null;
};
const MISSING_ROUTER = "Router not present, you can't use navigateTo yet. Please ensure there is a html component named ion-router";
const getRouter = () => {
    const router = document.querySelector("ion-router");
    if (isUndefined(router)) {
        throw MISSING_ROUTER;
    }
    return router;
};
/**
 * navigate to a new path in the application
 * It relies on existence of the rooter inside the page, must be called only
 * after the rou  ter is injected
 * @param partial part of the url to navigate to
 */
export const navigateTo = (partial, extraInfo) => {
    routingExtraInfo.extraInfo = extraInfo;
    getRouter().push(partial);
};
/**
 * Navigate to the previous page
 */
export const navigateBack = () => {
    getRouter().back();
};
export const SCIAPPS_DEVELOPER_ROUTE = "/developer-area";
export const SCIAPPS_HOME_ROUTE = "/my-datalabs";
/**
 * Navigate to the previous page
 */
export const navigateHome = () => {
    navigateTo(SCIAPPS_HOME_ROUTE);
};
/**
 * Safe register an event handler on the router
 * @param fn
 * @returns
 */
export const onRouteWillChange = (fn) => {
    getRouter().addEventListener("ionRouteWillChange", fn);
};
/**
 * Position an element from an other in a popover fashion
 * @param defaultState
 * @returns
 */
export const popover = (element, popover) => {
    const rect = element.getBoundingClientRect();
    popover.style.top = `${rect.top - 67}px`;
    popover.style.left = `${rect.left + 1}px`;
    popover.style.width = `${rect.width}px`;
};
